__turbopack_context__.v({
  "caretIcon": "InfoCard-module-scss-module__RbMpiq__caretIcon",
  "caretRightContainer": "InfoCard-module-scss-module__RbMpiq__caretRightContainer",
  "contentContainer": "InfoCard-module-scss-module__RbMpiq__contentContainer",
  "imageContainer": "InfoCard-module-scss-module__RbMpiq__imageContainer",
  "infoCard": "InfoCard-module-scss-module__RbMpiq__infoCard",
  "link": "InfoCard-module-scss-module__RbMpiq__link",
  "native": "InfoCard-module-scss-module__RbMpiq__native",
  "nativeInfoCardAnnonsLabel": "InfoCard-module-scss-module__RbMpiq__nativeInfoCardAnnonsLabel",
  "needSpace": "InfoCard-module-scss-module__RbMpiq__needSpace",
  "separator": "InfoCard-module-scss-module__RbMpiq__separator",
  "textContainer": "InfoCard-module-scss-module__RbMpiq__textContainer",
  "title": "InfoCard-module-scss-module__RbMpiq__title",
  "vignette": "InfoCard-module-scss-module__RbMpiq__vignette",
  "vignetteWrapper": "InfoCard-module-scss-module__RbMpiq__vignetteWrapper",
});
